var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignBottom = function SvgIconAlignBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1.75 1.75 0 0 0-1.75 1.75v12c0 .966.784 1.75 1.75 1.75h3.375a1.75 1.75 0 0 0 1.75-1.75v-12A1.75 1.75 0 0 0 9.375 2zm.25 13.5V4h2.875v11.5zM14.625 17.5a1.75 1.75 0 0 1-1.75-1.75V7.5c0-.966.784-1.75 1.75-1.75H18c.966 0 1.75.784 1.75 1.75v8.25A1.75 1.75 0 0 1 18 17.5zm.25-2h2.875V7.75h-2.875z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20.25a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconAlignBottom;